var map = {
	"./BankIcon.svg": 51846,
	"./Bell.png": 30898,
	"./HomeIcon.svg": 27517,
	"./KYCUpdationReports.svg": 96963,
	"./Tick.svg": 29496,
	"./actionView.svg": 52050,
	"./actiondelete.svg": 85520,
	"./actionedit.svg": 52797,
	"./actionmenu.svg": 45732,
	"./actionmenuvertical.svg": 94842,
	"./addressIcon.svg": 25162,
	"./app.svg": 68160,
	"./basicIcon.svg": 56396,
	"./blog.svg": 30847,
	"./calender.svg": 26973,
	"./close.svg": 35837,
	"./closeicon.svg": 5082,
	"./comingsoon.png": 2433,
	"./coupon.svg": 11045,
	"./customer.svg": 37511,
	"./dashboard.svg": 17461,
	"./downArrow.svg": 97526,
	"./download.svg": 91303,
	"./downloadReport.svg": 37697,
	"./duplicate.svg": 20430,
	"./edit.svg": 975,
	"./eye_closed.svg": 87525,
	"./eye_opened.svg": 49114,
	"./facebook.svg": 43479,
	"./facebookIcon.svg": 92952,
	"./familyIcon.jpg": 3202,
	"./faqdelete.svg": 75668,
	"./faqview.svg": 88190,
	"./filter.svg": 87985,
	"./financialYearReport.svg": 41237,
	"./goldmedal.svg": 72406,
	"./icondownarrow.svg": 22859,
	"./instaIcon.svg": 56103,
	"./key.svg": 97000,
	"./leftArrowWithoutTail.svg": 90043,
	"./leftTriangularArrow.svg": 14990,
	"./leftarrow.svg": 31783,
	"./live.png": 97271,
	"./misReport.svg": 15866,
	"./monthlySummary.svg": 10074,
	"./newedit.svg": 47331,
	"./newpause.svg": 19935,
	"./newplay.svg": 31881,
	"./order.svg": 51345,
	"./otherIcon.svg": 25804,
	"./product.svg": 4464,
	"./profileIcon.svg": 45613,
	"./profileIdentity.svg": 99144,
	"./profileplusIcon.svg": 41617,
	"./receiptClose.svg": 38191,
	"./referralcash.svg": 81317,
	"./referralearn.svg": 52250,
	"./referralreportImg.svg": 95223,
	"./referralreward.svg": 98105,
	"./referralshare.svg": 20245,
	"./refresh.svg": 32304,
	"./rewardReport.svg": 68956,
	"./rightArrowWithoutTail.svg": 63812,
	"./rightTriangularArrow.svg": 92059,
	"./roundedleftarrow.svg": 95984,
	"./roundedrightarrow.svg": 58815,
	"./schemeReports.svg": 79404,
	"./search.svg": 64343,
	"./showroomImg.svg": 67822,
	"./sliders.svg": 59411,
	"./summaryDashboards.svg": 23274,
	"./sync.svg": 38906,
	"./trendAnalysis.svg": 42130,
	"./twitterIcon.png": 23663,
	"./upArrow.svg": 7103,
	"./upload-icon.svg": 71722,
	"./user.svg": 10698,
	"./userDownArrow.svg": 14041,
	"./user_delete.png": 29444,
	"./user_reset.png": 87900,
	"./view.svg": 93436,
	"./viewIcon.svg": 8775,
	"./warning.svg": 42865,
	"./whatsApp.svg": 60081,
	"./whatsappIcon.png": 75516,
	"./workIcon.svg": 13735,
	"./youtubeIcon.png": 39245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;